import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ConnectionSuccessDialogData {
  connectionName: string;
}

export type ConnectionSuccessDialogResult = 'skip' | 'start-testing';

@Component({
  selector: 'app-connection-success-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './connection-success-dialog.component.html',
  styleUrls: ['./connection-success-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectionSuccessDialogComponent {
  private dialogRef = inject<MatDialogRef<ConnectionSuccessDialogComponent>>(MatDialogRef);
  data = inject<ConnectionSuccessDialogData>(MAT_DIALOG_DATA);


  onSkip(): void {
    this.dialogRef.close('skip' as ConnectionSuccessDialogResult);
  }

  onStartTesting(): void {
    this.dialogRef.close('start-testing' as ConnectionSuccessDialogResult);
  }
}
